export class MDCommonIcons
{
    ThreeDotsVert = 'common/three_dots_vert';
    Checkmark = 'common/check';
    ChevronRight = 'common/chevron_right';
    ChevronRight2 = 'common/chevron_right_2';
    ChevronLeft2 = 'common/chevron_left_2';
    ArrowDropdown = 'common/arrow_dropdown';
    ArrowDropright = 'common/arrow_dropright';
    ArrowRight = 'common/arrow_right';
    Person = 'common/person';
    People = 'common/people';
    Email = 'common/email';
    PeopleAdd = 'common/group_add';
    Close = 'common/close';
    ContentCopy = 'common/content_copy';
    Info = 'common/info';
    Warning = 'common/warning';
    Help = 'common/help';
    Home = 'common/home';
    Add = 'common/add';
    PlusSquare = 'common/plus_square';
    Storage = 'common/storage';
    ViewModule = 'common/view_module';
    Dashboard = 'common/dashboard';
    Extension = 'common/extension';
    Eye = 'common/eye';
    Edit = 'common/edit';
    Share = 'common/share';
    BusinessCenter = 'common/business_center';
    Business = 'common/business';
    Radio = 'common/radio_button_unchecked';
    RadioChecked = 'common/radio_button_checked';
    List = 'common/list';
    Link = 'common/link';
    Lock = 'common/lock';
    ListAlt = 'common/list_alt';
    Carousel = 'common/carousel';
    Label = 'common/label';
    PlaylistPlus = 'common/playlist_plus';

    Logo = 'common/logo';
    Grid = 'common/grid';
    Image = 'common/image';
    Desktop = 'common/desktop';
    Mobile = 'common/mobile';
    Phone = 'common/phone';
    Delete = 'common/delete';
    Menu = 'common/menu';
    PasswordKey = 'common/password_key';
    World = 'common/world';
    Space = 'common/space';
    Exit = 'common/exit';
    Cancel = 'common/cancel';
    QuestionMark = 'common/question_mark';
    OrganizationHouse = 'common/organization_house';
    Search = 'common/search';
    Refresh = 'common/refresh';
    Stop = 'common/stop';

    Pin = 'common/pin';
    Unpin = 'common/unpin';
    FlipToBack = 'common/flip_to_back';
    FlipToFront = 'common/flip_to_front';
    Collapse = 'common/collapse';

    LayoutTop = 'common/layout/top';
    LayoutLeft = 'common/layout/left';
    LayoutRight = 'common/layout/right';
    LayoutBottom = 'common/layout/bottom';
    LayoutVerticalCenter = 'common/layout/verticalCenter';
    LayoutHorizontalCenter = 'common/layout/horizontalCenter';
    Cross = 'common/layout/cross';

    CloudFunction = 'common/cloud_function';

    Report = 'common/report';
    Sheet = 'common/sheet';
    Page = 'common/page';
    ArrowInBox = 'common/arrow_in_box';

    Component = 'common/component';
    Position = 'common/position';
    Note = 'common/note';
    EventBinding = 'common/event_binding';
    PropBinding = 'common/prop_binding';
    NamedRange = 'common/named_range';
    Cell = 'common/cell';

    DiffAdded = 'common/diff_added';
    DiffRemoved = 'common/diff_removed';
    DiffChanged = 'common/diff_changed';

    Versions = 'common/versions';
    OpenInNew = 'common/open_in_new';
    Pages = 'common/pages';
    Spreadsheets = 'common/spreadsheets';

    Apps = 'common/apps';
    Settings = 'common/settings';
    StarRate = 'common/star_rate';
    PhotoFilter = 'common/photo_filter';
    FolderOpen = 'common/folder_open';
    BarChart = 'common/bar_chart';

    ArrowForward = 'common/arrow_forward';
    ReportProblem = 'common/report_problem';
    InfoCircle = 'common/info_circle';
    KeyboardBackspace = 'common/keyboard_backspace';

    Syncronization = 'common/synchronization';
    SyncronizationProblem = 'common/synchronization_problem';

    ViewportPhone = 'common/viewport_phone';
    ViewportTablet = 'common/viewport_tablet';
    ViewportDesktop = 'common/viewport_desktop';

    Copy = 'common/copy';
}

export class MDLogoIcons
{
    MintDataLogo = 'logo/mintdata_logo';
    MintDataLogo2 = 'logo/mintdata_logo2';
    MintDataLogo26 = 'logo/mintdata_logo_h26';
    MintDataLogoDialog = 'logo/mintdata_logo_dialog';
}

export class MDIcons
{
    public static readonly common:MDCommonIcons = new MDCommonIcons();
    public static readonly logo:MDLogoIcons = new MDLogoIcons();
}
